import api from ".";

const path = "/admin/bank-transactions";

const apiBankTransactions = api(path, {});
export default apiBankTransactions;
